import React from 'react';
import PropTypes from 'prop-types';
import MaterialCard from 'material-ui/Card/Card';

const Card = (props) => {
    const {
        children,
        className,
        containerStyle,
        style,
    } = props;

    return (
        <MaterialCard
            className={ className }
            containerStyle={ containerStyle }
            style={ style }
        >
            { children }
        </MaterialCard>
    );
};

Card.propTypes = {
    children: PropTypes.node.isRequired,
    className: PropTypes.string,
    containerStyle: PropTypes.object,
    style: PropTypes.object,
};

export default Card;



// WEBPACK FOOTER //
// ./src/components/ui/card/Card.js